import React, { FunctionComponent } from 'react';
import OnboardingStepLayout from '../components/OnboardingStepLayout';
import { useNavigate } from 'react-router-dom';
import { AppRoutes } from '../../../interfaces/store/appStore';
import { useAppActions } from '../../../stores/application/useAppActions';
import { useExternalHandlers } from '../../../services/actions/navigation/useExternalHandlers';
import { useAuthHandlers } from '../../../services/actions/auth/useAuthHandlers';
import { useAuthStore } from '../../../stores/auth/useAuthStore';
import SyncNetworkCard, { SYNC_NETWORK_PAGE_SUBTITLE } from '../components/SyncNetworkCard';
import { useOnboardingExtensionRequired } from '../hooks/useOnboardingExtensionRequired';

const SyncNetworkSection: FunctionComponent = () => {
    useOnboardingExtensionRequired();
    const { setOnboardingStep } = useAppActions();
    const navigate = useNavigate();
    const { openPermissionHandler } = useExternalHandlers();
    const { syncConnectionsHandler, syncConversationsHandler } = useAuthHandlers();
    const { store: { user, authData } } = useAuthStore();

    const continueToSurvey = () => {
        setOnboardingStep(4);
        navigate(AppRoutes.ONBOARDING_SURVEY);
    };

    const handleSyncClick = () => {
        if (user) {
            syncConnectionsHandler(user, false, authData);
            syncConversationsHandler();
        }
        continueToSurvey();
    };

    return (
        <OnboardingStepLayout
            activeStepIndex={2}
            title="Sync your network"
            subtitle={SYNC_NETWORK_PAGE_SUBTITLE}
        >
            <SyncNetworkCard
                onSync={handleSyncClick}
                onContinueWithoutSync={continueToSurvey}
                onOpenPermissions={openPermissionHandler}
            />
        </OnboardingStepLayout>
    );
};

export default SyncNetworkSection;
